var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKeepa1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 11,
    height: 11,
    fill: "url(#pattern0_641_458)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_641_458",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_641_458",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_641_458",
    width: 32,
    height: 32,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAfRJREFUWIXF1z9rVEEUBfDfPhOy6iamEVYs1EDSmWhjYyEJ2uh38Juo2FhoakEwrVjYaqciQlQQNPgB1IiFCpI1m8KIaDG7uD7fv3Hfsgcub5l5c8+ZN2dm7jZUxwwuYAVLOIrZXt8W3uE1HuE+tiNyF2IBa9jBr4qxg9uYH4Z4L1bxI4I4Hbu4jmYs+TzeDEGcjmc4VJX8JD7XSN6PD1isMvNRkA+KaOeRNwUXj4q8Hy8Ff/2D1chEl3G2F1cix15Nky+Ic/tOxgRitum21FKsRc6gkyGgE5njZn/gTKT6ugR0MZ0Ix+u+jISjxn6cT4SzfVxYmRAuliJ0BYMOIuui2cLPVNskWgW5l+CL/HW6VCKuCoq26KdEMGEentYg4ElB34GkBoKhkOBbQf+ZGjiWC/o6DbzAqYKX8kx4JNX2HtOptjITPp/ARomArAR7MtpmFfspCxuJUMONCw8JM+waz1HcSno/7o5gdmW40+NGqIR2VVefvo4b4i6075jjj5m+Cg4+XVH95MBzDhdxruJYuIF76camUL3GrOP/xDqm8pS1sTlC8o84XPZ5FoXqtW7yTRwvI+/joHCJ1PnZc8vxPEwJ1WvsGZF2+zUFa14FbaGAjBHSxS29rVaERoSQllA/LuMEjvn77/lbvMJjPDBwyBThNxb3vW2bQDxLAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeepa1);
export default __webpack_public_path__ + "static/media/keepa1.49fba95ea18684f5f9bad0e64dc0a939.svg";
export { ForwardRef as ReactComponent };